import { Attachment } from './attachment.model';
import {
  ContentSharingInput,
  ContentSharingOverview
} from './customer-portal/customer-portal.model';
import { TargetGroup } from './faq.model';
import { PinnedContentType } from './pinned-content-type.enum';

export interface News {
  id?: number;
  data?: NewsData;
  publishedAt?: string;
  timeAt?: string;
  publishedUntil?: string;
  timeUntil?: string;
  sharing?: ContentSharingInput;
  pinned?: boolean;
  pinnedStartDate?: string;
  pinnedEndDate?: string;
  pinnedContentType?: PinnedContentType;
  pinnedPosition?: number;
}

export interface NewsOverview {
  id?: number;
  title?: string;
  url?: string;
  sendNotification?: boolean;
  publishedAt?: string;
  publishedUntil?: string;
  sharings?: ContentSharingOverview;
  pinnedStartDate?: string;
  pinnedEndDate?: string;
  pinnedContentType?: PinnedContentType;
  pinnedPosition?: number;
}

export interface NewsData {
  title?: string;
  text?: string;
  excerpt?: string;
  href?: string;
  image?: Attachment;
  titleImageId?: string;
  showInHeader?: boolean;
  sendNotification?: boolean;
}

export interface NewsOverviewOnPrem {
  id?: number;
  uuid?: string;
  data?: NewsDataOnPrem;
  targetGroups?: TargetGroup;
  publishedAt?: string;
  publishedUntil?: string;
  sharing?: ContentSharingInput;
  sendNotification?: boolean;
}

export interface NewsDataOnPrem {
  title?: string;
  text?: string;
  excerpt?: string;
  href?: string;
  image?: Attachment;
  imageUrl?: string;
  showInHeader?: boolean;
}

export interface NewsSearchOptions {
  page: number;
  size: number;
}

export enum NewsNav {
  NEWS = 'news'
}

export interface NewsBulkDeleteInput {
  contentDeleteIds: number[];
}
